import React, { useState, useEffect } from 'react';
import { useParams,useOutletContext,  } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getHelpTextId } from 'api/company';
import Title from 'components/backoffice/texts/title';
import HelpTextForm from 'components/backoffice/forms/helpTextForm';

const EditHelpText = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [helpTextData, setHelpTextData] = useState(null);
  const { t } = useTranslation(['backoffice']);
  const { setTitle} = useOutletContext()


  useEffect(() => {
    const fetchHelpText = async () => {
      try {
        setLoading(true);
        const { data, status } = await getHelpTextId(id);
        if (status === 200) {
          setHelpTextData(data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchHelpText();
  }, [id]);

  useEffect(() => {
    if(helpTextData){
      setTitle(t('edit', {title:helpTextData?.title}))
    }
    return () => {
      setTitle('');
    };
  },[helpTextData, setTitle])

  return (
    <div className="mt-2">
      <Title text={t('editHelpText')} />
      <HelpTextForm helpTextData={helpTextData} isLoading={loading} isEditing={true} />
    </div>
  );
};

export default EditHelpText;
